import { useEffect, useRef } from "react";
import FormCreator from "../../../components/Forms/FormCreator";
import { viewCommitteeListDataForm } from "../data/AddCommitteeApprovalForm.Data";
import SwalAlert from "../../../services/swalService/SwalService";
import Buttons from "../../../components/ui/button/Buttons";
import { useState } from "react";
import { decryptAESID } from "../../../utils/Encryption";
import { useAddEditCommitteApprovalMutation, useLazyGetCommitteeApprovalByMemberIdQuery } from "../../../app/services/CommitteeApprovalManagement/CommitteApprovalManagementApi";

const EditCommitteApprovalForm = (props) => {
    const viewCommitteeListDataRef = useRef();
    const selectedId = props.selectedId ? decryptAESID(props.selectedId) : 0;
    const [viewList, setViewList] = useState(viewCommitteeListDataForm)
    const { success, error } = SwalAlert();

    const [getMemberDetailById, { isSuccess: isSuccessMemberById, isFetching: isFetchingMemberbyID, data: memberlistData }] = useLazyGetCommitteeApprovalByMemberIdQuery();
    const [addEditCommitteApprovalMember, { isLoading: isAddMemberLoading, isSuccess: isAddMemberSuccess, data: addMemberResponse }] = useAddEditCommitteApprovalMutation();

    useEffect(() => {
        if (selectedId) {
            getMemberDetailById(selectedId);
        }
    }, []);

    useEffect(() => {
        if (!isFetchingMemberbyID && isSuccessMemberById && memberlistData) {
            let Data = { ...viewList }
            const { name, email } = memberlistData;
            Data.initialState = {
                name,
                email
                
            };
            setViewList(Data);
        }
    }, [isFetchingMemberbyID, isSuccessMemberById, memberlistData]);

    useEffect(() => {
        if (!isAddMemberLoading && isAddMemberSuccess && addMemberResponse) {
            if (!addMemberResponse.hasError) {
                success("Record has been updated successfully.");
            } else {
                error(addMemberResponse.errorMessage);
            }
        }
    }, [isAddMemberLoading, isAddMemberSuccess, addMemberResponse]);

    const handleUpdate = () => {
        const formData = viewCommitteeListDataRef.current.getFormData();
        if (formData.password !== formData.confirmPassword) {
            error("Password and Confirm Password do not match.");
            return; 
        }
        const request = {
            AdminID: memberlistData?.adminID || 0,
            Name: formData.name,
            Email: formData.email,
            Password:formData.password || null,
            CreatedBy: 115,
            CreatedAppId: 1
        }
        addEditCommitteApprovalMember(request)
    }

    return (<>
        <div className='row mt-4'>
            <FormCreator ref={viewCommitteeListDataRef} {...viewList} />
            <div className='col-lg-1 d-flex justify-content-start'>
                <Buttons
                    buttonText="Save"
                    buttonTypeClassName="success-btn ml-2 mt-4"
                    onClick={handleUpdate}
                />
            </div>

        </div>
    </>)
}
export default EditCommitteApprovalForm;